const STICKER_URL_PATTERN = /^https?:\/\/[^\s]+\.(webp|png)$/i;

export const isStickerUrl = (value) =>
  typeof value === 'string' && STICKER_URL_PATTERN.test(value.trim());

export const buildStickerAction = (url) => ({
  type: 'send_message',
  typeMessage: 'media',
  content: {
    name: 'sticker.webp',
    type: 'image/webp',
    url: String(url).trim(),
    fileText: '',
    isSticker: true,
  },
});

export const canUseSticker = (data) =>
  !data?.options?.length &&
  !data?.advanced?.dynamic_buttons &&
  !data?.advanced?.location &&
  !data?.advanced?.request_contact &&
  !data?.advanced?.url_button_url &&
  !data?.file &&
  !data?.file_url_variable;
